import { Button } from '#/components/Button/Button';
import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownMenu } from '#/components/Dropdown/menus/Menu/DropdownMenu';
import { DropdownMenuItem } from '#/components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { I18nFn } from '#/i18n/types/I18nFn';
import { useRsvpAnswer } from '#/modules/listing/events/hooks/useRsvpAnswer';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import { RsvpButtonMenuItem } from './RsvpButton.styled';

const TRIGGER_TEXT = (i18n: I18nFn) =>
  ({
    GOING: i18n('Going'),
    NOT_GOING: i18n('Not Going'),
    INTERESTED: i18n('Interested'),
  }) as Record<string, string>;

type Props = {
  listingId: string;
};

export function RsvpButton({ listingId }: Props) {
  const { i18n } = useI18n();

  const { answer, postRsvp } = useRsvpAnswer(listingId, false);
  const triggerText =
    answer && TRIGGER_TEXT(i18n)[answer]
      ? TRIGGER_TEXT(i18n)[answer]
      : i18n('RSVP');

  return (
    <Dropdown
      trigger={
        <Button
          type="inert"
          variant="primary"
          icon={
            answer
              ? { name: 'checkmark-filled' }
              : { name: 'chevron-down', position: 'right' }
          }
        >
          {triggerText}
        </Button>
      }
      qaId="rsvp-dropdown"
    >
      <DropdownMenu
        width="147px"
        qaId="rsvp-dropdown-menu"
        placement="bottom-right"
        mobilePlacement="top-right"
      >
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-going"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'going',
                listing_id: listingId,
              });
              postRsvp('GOING');
            }}
          >
            {i18n('Going')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-interested"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'interested',
                listing_id: listingId,
              });
              postRsvp('INTERESTED');
            }}
          >
            {i18n('Interested')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-not-going"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'not_going',
                listing_id: listingId,
              });
              postRsvp('NOT_GOING');
            }}
          >
            {i18n('Not Going')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
      </DropdownMenu>
    </Dropdown>
  );
}
